<template>
  <div id="page-wrapper" class="page-wrapper">
    <div class="row site-header">
      <div class="site-content">
        <nav class="navbar navbar-default">
          <div class="container-fluid">
            <div class="navbar-header">
              <a class="navbar-brand" href="#">
                <div class="site-logo"></div>
                <h3>Saint Lucia NEIS</h3>
              </a>
              <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                      data-target=".navbar-collapse" aria-expanded="false">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
            </div>
            <div class="collapse navbar-collapse" id="neis-navbar">
              <ul class="nav navbar-nav navbar-right">
                <li>
                  <a data-v-02160f18="" href="http://cdsf.govt.lc/">
                    <i data-v-02160f18="" class="fa fa-archive"></i>
                    <span data-v-02160f18="">Central Data Storage Facility (CDSF)</span>
                  </a>
                </li>
                <li>
                  <a href="#" v-scroll-to="'#indicators'">
                    <i class="fa fa-check-circle"></i>
                    Indicators
                  </a>
                </li>
                <li>
                  <a href="#" v-scroll-to="'#contact'">
                    <i class="fa fa-phone"></i>
                    Contacts
                  </a>
                </li>
                <li v-if="isAuthenticated">
                  <router-link to="./profile">
                    <i class="fa fa-tachometer"></i>
                    Dashboard
                  </router-link>
                </li>
                <li v-if="!isAuthenticated">
                  <router-link to="./login">
                    <i class="fa fa-sign-in"></i>
                    Login as Staff
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
    </div>
    <div class="hero row">
      <div class="hero-content">
        <div class="col-sm-4 col-xs-12">
          <h1 class="title-heading">National Environmental Information System (NEIS)</h1>
          <p>
             Project Reporting System for Multilateral Environmental Agreement (MEA) Implementation and Environmental Information Management
          </p>
          <btn @click="siteRedirect('reports')" class="btn-explore">Explore Reports</btn>

        </div>
        <div class="col-sm-8 col-xs-12">
          <div class="chart-image"></div>
        </div>
      </div>
    </div>
    <div class="meas row">
      <div class="row row-span meas-title">
        <h1>Multilateral Environmental Agreements (MEA)</h1>
        <h2>Multi-lateral Environmental Agreements are legal instruments with binding effects on countries that have agreed to become parties. They are also the means by which global agreements and direction can be achieved on critical environmental and sustainable development issues; this includes climate change, loss of biodiversity and the degradation of land.</h2>
      </div>
      <div id="meas" class="row row-span row-meas-list">
        <div class="col-sm-4 col-xs-12 card col-meas" v-scroll-to="'#indicators'"
            v-for="(mea, index) in meas" :id="'mea_'+index" @click="filterByMea($event, mea)" :style="getMEAStyle(mea)"
            @mouseenter="hoverMEA = mea"
              @mouseleave="hoverMEA = {}"
            >
          <i class="fa fa-file-text" ></i>
          <h1 >{{ mea.abbreviation }}
          </h1>
          <h2>{{ mea.name }}</h2>
        </div>
      </div>
    </div>
    <div class="row indicators">
      <div class="row inline row-span categories-container">
       <h1 id="indicators">Explore {{ selectedMEA.abbreviation }} MEA</h1>
       <h2>Indicators are measures of the state of the environment, providing insight into its health, quality and management. Indicators are presented as a statistic or value of the presence or level of the factor affecting the environment. The five, key global environmental indicators, for example, are biological diversity, food production, average global surface temperature and CO2 concentration in the atmosphere, human population and resource depletion.  </h2>
       <h1 id="indicators" class="mea-subtitle" >Categories</h1>
       <div class="row row-categories">
         <span class="indicator-category" v-if="initLaunch" v-for="category in categories">

           <btn @click="filterByCategory(category.id)"
              :style="getCategoryStyle(category)"
              @mouseenter="hoverCategory = category"
              @mouseleave="hoverCategory = {}"
            >
              {{ category.name }}
            </btn>
         </span>
         <span class="indicator-category" v-if="!initLaunch" v-for="category in filteredCategories">
           <btn @click="filterByCategory(category.id)"
              :style="getCategoryStyle(category)"
              @mouseenter="hoverCategory = category"
              @mouseleave="hoverCategory = {}">
              {{ category.name }}
            </btn>
          </span>
       </div>
      </div>

      <div class="row row-span collection">
        <h1 id="indicators" class="mea-subtitle">Indicators</h1>
        <div class="priority-legend">
          <span class="priority">
              <i :class="'fa fa-check-circle low'"></i>Low
          </span>
          <span class="priority">
              <i :class="'fa fa-check-circle medium'"></i>Medium
            </span>
            <span class="priority">
              <i :class="'fa fa-check-circle high'"></i>High
          </span>
        </div>
        <div v-if="initLaunch">
          <div class="card" v-for="(indicator, index) in indicators">
            <div :id="'indicator_' + index" class="indicator-container" v-if="indicator.name != undefined"
              @click="setSelectedIndicator($event, indicator)">
              <div class="indicator-icon" :style="indicatorStyle" >
                <i class="fa fa-line-chart"></i>
              </div>
              <div  :class="{ 'indicator-content': true, 'indicator-no-report': ! indicator.has_report}">
                <div class="row">
                  <div class="col-sm-4 indicator-name">
                    <h1>{{ indicator.name  }}</h1>
                    <span class="priority-label">Priority: </span>
                    <span class="indicator-priority" >
                      <i :class="'fa fa-check-circle ' + indicator.priority"></i>
                      {{ indicator.priority | capitalize }}
                    </span>
                  </div>
                  <div class="col-sm-8 indicator-description">
                    <div class="description">
                      {{ indicator.description | truncate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div v-if="filteredIndicators.length > 0">
            <div class="card" v-for="(indicator, index) in filteredIndicators">
            <div :id="'indicator_' + index" class="indicator-container" v-if="indicator.name != undefined"
              @click="setSelectedIndicator($event, indicator)">
              <div class="indicator-icon" :style="indicatorStyle" >
                <i class="fa fa-line-chart"></i>
              </div>
              <div :class="{ 'indicator-content': true, 'indicator-no-report': ! indicator.has_report}" >
                <div class="row">
                  <div class="col-sm-4 indicator-name">
                    <h1>{{ indicator.name  }}</h1>
                    <span class="priority-label">Priority: </span>
                    <span class="indicator-priority" >
                      <i :class="'fa fa-check-circle ' + indicator.priority"></i>
                      <span>{{ indicator.priority | capitalize }}</span>
                    </span>
                  </div>
                  <div class="col-sm-8 indicator-description">
                    <div class="description">
                      {{ indicator.description | truncate }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

    <div class="report-container">
      <div class="report row">
        <div class="row row-span">
          <h1>View Saint Lucia's Progress </h1>
          <h2>Explore Reports for Saint Lucia's Multilateral Environmental Agreements</h2>
        </div>

        <div class="explore-container">
          <div class="explore-content" @click="viewReport()">
            <a>Explore Reports</a>
          </div>
        </div>
      </div>
    </div>

    <eis-footer></eis-footer>

  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import ChartDisplay from './report/ChartDisplay';
import store from '../store.js';
import config from '../config';
import EisFooter from './EisFooter';

import { dashboard_routes } from '../routes'
import moment from 'moment';


export default {
    data () {
        return {
          path: null,
          baseUrl: '/reports/',
          filteredIndicators: [],
          filteredCategories: [],
          initLaunch: true,
          selectedIndicator: null,
          selectedCategory: {},
          hoverCategory: {},
          hoverMEA: {},
          selectedMEA: {},
          routes: dashboard_routes,
          CDSFURL: config.CDSFURL,

        }
    },
    methods: {
      invalidAction: function() {
        this.$alert({
          title: 'Action Required',
          content: 'You cannot view reports without first selecting an indicator!'
        }, (msg) => {})
      },

      resetContentState:function(target) {
        let division, siblings, active;

        if (Array.isArray(target)) {
          for (var h=0; h<target.length; h++) {
            division = target[h];

            if (division == 'mea') {
              active = 'active';
              siblings = document.querySelectorAll('.col-meas.' + active);
            }
            else {
              active = 'indicator-active';
              siblings = document.querySelectorAll('.indicator-container.'+ active);
            }

            for (var i=0; i<siblings.length; i++)
              siblings[i].classList.remove(active)
          }
        }
      },

      siteRedirect: function(target) {
        let path = null;
        this.routes.forEach(function(route) {
          let name = route.meta.name;
          if (name.toLowerCase() == target) path = route.path;
        });

        if (path != null) this.$router.push(path);
      },

      viewReport: function() {
        let selectedIndicator = this.selectedIndicator;

        if(selectedIndicator != null) {
          store.state.selectedIndicator = selectedIndicator;
        }
        this.$router.push('/reports');
      },

      getActiveClass: function(category) {
        let selectedCategory = this.selectedCategory;
        return selectedCategory === category ? 'btn active': 'btn';
      },

      getCategoryStyle: function(category){
        let color = this.selectedMEA.color || 'rgb(6, 186, 252)';

        if(category.id == this.selectedCategory ){
          return {
            "background-color": color,
            "color": "white",
          };
        }else if (category.id == this.hoverCategory.id){
          return {
            "background-color": color,
            "color": "white",
            opacity: 0.7
          };
        }
        return {
          color: color,
          "background-color": category.has_report ? 'white' : '#eaeaea',
        };
      },
      getMEAStyle: function(mea){
        let color = mea.color || 'rgb(6, 186, 252)';

        if(mea.id == this.selectedMEA.id ){
          return {
            "background-color": color,
            "color": "white",
          };
        }else if (mea.id == this.hoverMEA.id){
          return {
            "background-color": color,
            "color": "white",
            opacity: 0.7
          };
        }
        return {
          color: color,
          "background-color": "white",
        };
      },

      setActiveMea: function(event) {
        let target_id = event.currentTarget.id;
        let element = document.getElementById(target_id);

        this.resetContentState(['mea','indicator']);
        if(!element.classList.contains('active'))
          element.classList.add("active");
      },

      setSelectedIndicator: function($event, indicator) {
        let target_id = event.currentTarget.id;
        let element = document.getElementById(target_id);

        // reset and set selected indicator
        this.resetContentState(['indicator']);
        this.selectedIndicator = indicator
        store.state.reportFilter = true;

        if(!element.classList.contains('indicator-active'))
          element.classList.add("indicator-active");
      },

      getIndicatorCount: function(indicators) {
        return indicators == undefined? 0 : indicators.length;
      },

      filterByMea: function(event, mea) {
        this.selectedMEA = mea;
        this.filteredCategories = mea.categories.map(function(category_id){
          return this.categories.find((category) => category_id === category.id)
        }, this);
        this.filteredIndicators = mea.indicators.map(function(indicator_id){
          return this.indicators.find((indicator) => indicator_id === indicator.id)
        }, this);
        this.initLaunch = false;
        this.setActiveMea(event);

      },

      filterByCategory: function(category) {
        let meaObject = this.meas.find((mea) => mea.categories.includes(category));
        if (meaObject){
          this.filteredCategories = meaObject.categories.map(function(category_id){
            return this.categories.find((categoryInStore) => category_id === categoryInStore.id)
          }, this);
          this.filteredIndicators = this.indicators.filter((indicator) => indicator.category === category)
        }
        this.selectedCategory = category;
        this.initLaunch = false;
      },

      getCategory: function(categoryId){
        let foundCategory = this.categories.find(category => category.id === categoryId);
        return foundCategory;
      },

      shuffle: function(array) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;

          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }

        return array;
      },
    },

    mounted: function(){
    },

    computed: {
      ...mapState({
        // Extract things like this out into a Mixin
        meas: function(state) {
          return state.meas;
        },

        categories: function(state){
          return state.categories;
        },

        indicators: function(state) {
          return state.indicators;
        },

        fullName: function (state) {
          const user = state.user;
          return (user)? user.first_name+" "+user.last_name : user.email
        },
      }),

      year: function() {
        return moment().format('YYYY')
      },
      indicatorStyle: function(){
        return { 'background-color': this.selectedMEA.color }
      },

      ...mapGetters([ 'isAuthenticated' ]),
    },
    components: { ChartDisplay, EisFooter },

    async beforeRouteEnter (to, from, next) {
      await store.dispatch('fetchPageContent');
      next();
    },
};

</script>

<style lang="scss" scoped>
@import "../css/constants";

h1{ font-family: 'Roboto Slab', serif; font-size: 2.4em}
.row-span { margin: 25px 0 0 0; }
.page-wrapper{ font-family: 'Roboto Slab', serif; height: 100vh; width: 100vw;
  .row{
    padding: 20px 50px;
  }

  .site-content {
    height: auto;
    width: 90%;
    margin: 0 auto;
    padding: 0 10px;
  }

  .site-content:after { content: ""; display: table; clear: both; }
  .site-header{
    padding-top: 20px;
    padding-bottom: 20px;

    .title-container { float: left;
      .icon-logo{ display: inline-block; margin-left: 0rem; }
      .site-title {
        height: auto;
        display: inline-block;
        margin: 14px 10px 0;
        vertical-align: top;

        h3 {
          font-weight: bold;
          font-family:'Roboto Slab', serif;
          font-size: 1.8em;
          margin: 0 0 15px 0;
          padding: 0;
        }

        span {
          font-size: 1.1em;
          margin: 0;
        }
      }
    }

    .sub-menu {
      font-family: 'Roboto', sans-serif;
      height: 100%;
      float: right;

      ul {
        margin-top: 20px;

        li:first-child { border: none; }
        li:last-child { padding-right: 0; }
        li {
          display: inline;
          font-size: 1.0em;
          font-family: 'Roboto', sans-serif;
          border-left: 1px solid $gray3;
          padding: 5px 0 0 10px;
          margin: 0 0 0 10px;
          a, a:visited, a:focus, a:active { color: #337DED; text-decoration: none;}
          a:hover { color: #56CCF2; }
        }
      }

      .user-greet span {
        font-family: 'Roboto Slab', serif;
        float: right;
      }
    }
  }
}

.hero{
  width: 100%;
    color: #ffffffbf;
    margin: 0px;

    background: #56CCF2;  /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2F80ED, #56CCF2);  /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2F80ED, #56CCF2); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

    .hero-content {
      font-family: 'Roboto', sans-serif;
      width: 90%;
      height: 100%;
      margin: 0 auto;
    }

    .col-sm-8 { height: 100%; padding: 0 30px; }
    .chart:after { content: ""; display: table; clear: both; }
    .chart-image {
      width: 20vw;
      height: 35vh;
      background: url('../assets/preview.png') no-repeat;
      margin: 0 auto;
      background-size: 100%;
      float: right;
    }

    h1{
      width: 130%;
      font-family: 'Roboto Slab', serif;
      font-size: 2.25em;
      line-height: 1.273em;      
      color: #fff;
      text-shadow:  0px 8px 15px rgba(0, 0, 0, 0.1);
      height: auto;
    }

    .title-heading { margin-top: 15px; }
    p {
      font-size: 0.938em;
      font-family: inherit;
      font-weight: 300;
      margin: 0;
      padding: 20px 0;
      line-height: 1.32em;
      color: #fff;
      text-shadow:  0px 8px 15px rgba(0, 0, 0, 0.1);
    }

    .btn-explore {
      font-size: 0.948em;
      position: relative;
      bottom: 15%;
      font-weight: 900;
      cursor: pointer;
      outline: none;
      padding-left: $p24;
      padding-right: $p56;
      background: white;
      box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
      transition: all 0.43s ease 0s;

      border-radius: 100px;
      color: #243c98;
      border: none;

      background-image: url('../assets/sign-in-arrow.svg');
      background-size: $p20;
      background-position: 155px 12px;
      background-repeat: no-repeat;
      &:focus { box-shadow: none; outline: none; }
      &:active { background-color: white; color: $gkred; }
      &:hover {
        color: #56CCF2;
        padding-left: 40px;
        padding-right: 40px;
        background-position: 120% 11px;
      }
    }

    .col-sm-4 {
      height: 100%;
      position: relative;
    }
}

.meas{
    height: auto;
    text-align: center;
    padding: 20px;

    .row-meas-list{
      width: 80%;
      margin: auto;
      height: 45vh !important;

      .col-meas{
        height: 100%;
      }
    }

    .card{
      box-shadow: inset 0 0 0 1px #f9f9f9;
    }

    .meas-title{
      h2{
        font-family: "Roboto", sans-serif;
      }
      h2, h1{
        margin-left: auto;
        margin-right: auto;
        width: 70%;
        line-height: 1.2em;
        height: auto;
      }
    }

    h1{
      position: relative;
      font-size: 2.2em;
      text-shadow:  0px 6px 15px rgba(0, 0, 0, 0.1);
      margin-bottom: 25px;
      line-height: 0.9em;
      text-align: center;
      height: auto;
    }

  .row{
    .block { height: 200px;
      i { font-size: 2.6em; margin-bottom: 5px; }
      h2 { font-size: 2.6em; line-height: 0.830em;
      }
    }
    .col-meas {
      cursor: pointer;
      overflow: hidden;

      i { font-size: 3.2em; display: block; margin-bottom: 30px; }
      h2 { font-family: 'Roboto', sans-serif;  font-size: 0.848em; color: inherit; line-height: 1.25em; }
      h1 {
        font-family: 'Roboto Slab', serif;
        font-size: 1.8em;
        text-shadow: none;
        margin: 10px 0;
        height: auto;

        .badge {
          position: absolute;
          font-size: 8px;
          top: -10px;
          right: -10px;
          background-color: #3fba7a;
          padding: 5px 5px 2px 5px;

          border: 1px solid #3fba7a;
          box-shadow: 3px 2px 5px rgba(0, 0, 0, 0.1);
          text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}

.indicators{
  height: auto;
  padding: 0;
  margin-bottom: 40px;

  h1.mea-subtitle{
    font-size: 1.5em;
  }

  .categories-container{

    h1, h2 {
      font-family: 'Roboto', sans-serif;
      width: 70%;
      padding: 20px;
      margin-left: auto;
      margin-right: auto;
      line-height: 25px;
      height: auto;
    }

    h1.mea-subtitle{
      font-size: 1.5em;
    }
  }

  h1{ font-size: 2.2em; text-shadow:  0px 6px 15px rgba(0, 0, 0, 0.1); height: auto;}
  h2{ font-family: "Roboto Slab", serif}
  .inline {
    text-align: center;
    border: none;

    .row.row-categories{
        width: 70%;
        margin-left: auto;
        margin-right: auto;
      }

    .row {
      padding: 15px 0;
      margin: 0;

      .indicator-category{
        margin-left: 5px;
        margin-right: 5px;
        margin-top: 10px;
        display: inline-block;
      }

      .btn {
        color: #56CCF2;
        background-color: #fff;  /* fallback for old browsers */
        border-radius: 20px;
        box-shadow: 0px 6px 10px rgba(146, 146, 146, 0.05);
        transition: all 0.5s ease 0s;
        &:hover { background-color: #56CCF9; color: #fff; }
        &:focus { outline:0; }
        &:active { outline: none; border: none; }
      }
      .active { background-color: #56CCF9; color: #fff; }
      .col-sm-2 { margin-top: 18px; }
    }
  }

  .collection {
    width: 75%;
    margin-right: auto;
    margin-left: auto;

    .priority-legend{
      text-align: center;
      font-size: 0.8em;
      margin-bottom: 15px;

      .priority{
        margin-left: 10px;
        display: inline-block;
      }

      .low { color: #eac913;  }
      .medium { color: #1086e0;  }
      .high { color: #40e010; }
    }

    h1{
      text-align: center;
      padding-bottom: 10px;
    }
    h1.mea-subtitle{
      font-size: 1.5em;
    }

    .card:last-child { margin-bottom: 0; }
    .card {
      padding: 0;
      margin-bottom: 4px;
      box-shadow: inset 0 0 0 1px #f9f9f9;

      .indicator-container:after { content: ""; display: table; clear: both; }
      .indicator-container {
        width: 100%;
        height: 100%;
        padding: 0; margin: 0;
        text-align: center;
        cursor: pointer;
        z-index: 1;

        .indicator-icon {
          width: 10%;
          height: 150px;
          float: left;
          background-color: #56CCF9;

          display: flex;
          justify-content:center;
          align-content:center;
          flex-direction:column; /* column | row */
          i {
            color: #fff;
            font-size: 2.0em;
          }
        }

        .indicator-content {
          width: 90%;
          height: 150px;
          float: left;
          border-left: 1px solid #f9f9f9;
          border-right: 1px solid #f9f9f9;

          padding: 0 10px;
          text-align:left;
          vertical-align: middle;

          &.indicator-no-report{
            background-color: #eaeaea;
          }
          .row {
            margin: 0;
            padding: 0;
            border: 0;
            height: 100%;
            .indicator-description{
              height: 100%;

              .description{
                font-family: 'Roboto', sans-serif;
                margin-top: 15px;
                margin-bottom: 15px;
                height: calc( 100% - 30px);
                overflow: hidden;
                line-height: 20px;
                font-size: 0.8em;
              }
            }
            .col-sm-6, .indicator-name {
              padding: 0;
              height: 100%;

              b {
                display: block;
                position: relative;
                font-size: 0.9em;
                color: #56CCF2;
                margin-top: 5px;

                .tag {
                  position: absolute;
                  font-size: 0.5em;
                  padding: 3px 13px;
                  margin-left: 6px;
                  margin-top: -6px;

                  background-color: $gray2;
                  border: 1px solid $gray3;
                  border-radius: 30px;
                }
              }
              .indicator-priority{
                font-size: 0.75em;
                .low { color: #eac913;  }
                .medium { color: #1086e0;  }
                .high { color: #40e010; }
              }
              span { font-family:'Roboto', sans-serif; font-size: 0.86em; color: $gray7; }
              h1 {
                font-size: .84em;
                font-weight: bold;
                margin: 5px 0 2px 0;
                text-shadow: none;
                color: #404040;
                margin-top: 20px;
                height: auto;
                text-align: left;
                line-height:1.2rem;
              }

              .avatar{
                margin-top: 26px;

                .fa-check-circle { font-size: 1.25em;}
                .low { color: #eac913;  }
                .medium { color: #1086e0;  }
                .high { color: #40e010; }
                i { color: white; padding: 14px 3px; border-radius: 60px; }
                span {
                  height: 100%;
                  font-size: 0.875em;
                  font-weight: 800;
                }
              }
            }
          }
        }

        .indicator-total {
          width: 10%;
          height: 100px;
          float: left;
          border: 0;

          display: -webkit-box;
          display: -webkit-flex;
          display: -moz-box;
          display: -ms-flexbox;
          display: flex;
          -webkit-flex-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          justify-content: center;

          span {
            font-size: 1.0em;
            font-weight: bold;
            padding: 10px;
          }
        }
      }

      .indicator-active {
        background: #e8f9ff;
        box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.2);
        transform: scale(1.04);
        z-index: 999;
      }
    }
  }

  .row{
    .block {
      height: 200px;
      i { font-size: 2.6em; margin-bottom: 5px; }
      h2 { font-size: 2.6em; line-height: 0.830em; }
    }
  }
}

.report-container {
  font-family: 'Roboto', sans-serif;
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 15px 0;

  background: -webkit-linear-gradient(to right, #2F80ED, #56CCF2);
  background: linear-gradient(to right, #2F80ED, #56CCF2);

  .row {
    width: 70%;
    margin: 20px auto;
    text-align: center;

    h1, h2 {
      line-height:1.1em;
      text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
      height: auto;
    }

    h1 { color: #fff; }
    h2 { font-family:'Roboto',sans-serif; color: #f2f2f2; margin-top: 20px; }

    .explore-container {
      width: auto;
      max-width: 220px;

      height: auto;
      margin: 20px auto 0 auto;
      cursor:pointer;

      .explore-content {
        margin: 0;

        a{
          display: block;
          font-size: 0.8em;
          font-weight: bold;
          letter-spacing: 1.2px;
          padding: 10px 10px;

          transition: all 0.43s ease 0s;
          text-transform: uppercase;
          text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.4);
          color: #fff;

          border-radius: 60px;
          border: 2px solid #fff;

          &:hover {
            color: #46A5B1 !important;
            background: #fff;
            text-shadow: none;
            text-decoration: none;
          }

          &:focus, &:disabled,
          &:active, &:visited { color: #fff; text-decoration: none; }
        }
      }

      i{ display: block; }
    }
  }
}

// .container-fluid > div{ padding: 0px; }
.eis-footer {
  margin-left: 17px !important;
  width: 100%;
  height:auto !important;
  background-color: #fff;

  .row { padding-top: 10px; padding-bottom: 10px; margin-left:30px !important; }
  .contacts{ line-height: 20px; }

  p { font-size: 12px; }
  p.header {
    font-size: 15px;
    font-weight: bold;
    color: #7a7f89;
  }
}

.navbar-default{
  border:0px;
  margin-bottom:0px;
}

.navbar-toggle{
  float:left;
}

.navbar-brand{
  float:right;
  & > * {
    display: inline-block;
  }
  img{
    float:left;
  }
  h3 {
    float:right;
  }
  .site-logo{
    background-image: url("../assets/coat_of_arms.png");
    background-size: 40px 40px;
    width: 40px;
    height: 40px;
    position: relative;
    top: -15px;
    left: -5px;
  }
}

.navbar-nav{
  a{
    font-size:0.8em;
  }
}


@media (max-width:1192px){
  .hero {

    h1{
      font-size: 1.75em;
      line-height: 1.25em;
    }

    p{
      font-size: 0.938em;
    }
  }
}

@media (max-width:1080px){
  .navbar-header {
    float: none;
  }
  .navbar-left,.navbar-right {
      float: none !important;
  }
  .navbar-toggle {
      display: block;
  }
  .navbar-collapse {
      border-top: 1px solid transparent;
      box-shadow: inset 0 1px 0 rgba(255,255,255,0.1);
  }
  .navbar-fixed-top {
      top: 0;
      border-width: 0 0 1px;
  }
  .navbar-collapse.collapse {
      display: none!important;
  }
  .navbar-nav {
      float: none!important;
      margin-top: 7.5px;
  }
  .navbar-nav>li {
      float: none;
  }
  .navbar-nav>li>a {
      padding-top: 10px;
      padding-bottom: 10px;
  }
  .collapse.in{
      display:block !important;
  }
}

@media (max-width:800px){

  .hero{
    h1{
      margin: 0px;
    }

  }

  h1, h2{
    line-height: 1 !important;
    width: inherit !important;
    margin: 1em auto;
  }

  h1{
    font-size: 1.5em !important;
    text-align: center;
  }

  h2{
    font-size: 0.8em !important;
    text-align: center;
    width: 135% !important;
    padding: 0 2em !important;
    margin-left: -17% !important;
    line-height:1.5 !important;
  }


  // Hero Elements
  .hero.row{
    height: auto;
  }

  .hero-content {
    button {
      background-position: 95% 12px !important;
      width: 110%;
    }
  }
  .col-xs-12{
    height: 50% !important;

    .title-heading{
      font-size: 1.5em !important;
      line-height: 1 !important;
    }
    p {
      text-align: justify;
      font-size: 0.95em;
    }
    .chart-image{
      width: 200px !important;
      height: 160px !important;
      background-size: 200px !important;
      float: none;
    }
  }
  // END Hero Elements

  .report.row{
    width: inherit !important;
    padding: 0px 10px;
  }

  .indicators .collection{
    width: inherit !important;
  }

  // MEAs Listing
  #meas {
    width: 100%;
    .card {
      height: 20vh !important;

      i, h1, h2 {
        margin: 0.2em auto !important;
      }

      i {
        font-size: 1em !important;
      }
      h1 {
        font-size: 1em !important;
      }
      h2 {
        font-size: 0.8em !important;
        text-align:center;
        width: inherit !important;
      }
    }
  }
  // END MEAs Listing


  // Categories
  .row.row-categories{
    width: 135% !important;
    margin-left: -17% !important;

    button{
      font-size: .7rem;
    }
  }

  .indicators [id^="indicator_"] {
    .indicator-icon {
      i {
        font-size: 1.2em !important;
      }
    }

    h1 {
      margin: 0.5em 0 !important;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow:hidden;

    }

    .indicator-description { display: none; }
    .indicator-name{
      // basically doing a col-sm-12 where when the
      // description is set to display:none;
      width: 100%
    }
  }
}


@media only screen and (min-width: 768px) {
  /* For mobile phones: */ 
}

@media only screen and (min-width: 468px) and (max-width: 768px) {
  /* For mobile phones: */ 
}

@media only screen and (max-width: 468px) {
  /* For mobile phones: */ 
  .indicator-content {
    width: calc(100% - 10px)!important;
    
    .row {
      margin: 0;
      padding: 0;
      border: 0;
      height: 100%;
      
      .indicator-description{ display: none; }
      .col-sm-6, .indicator-name {
        padding: 0;
        height: 100%;

        span { font-family:'Roboto', sans-serif; font-size: 0.66em; color: $gray7; }
        h1 { font-size: 0.94em !important; font-weight: bold; }       
      }
    }
  }
  
  .indicator-icon { 
    width: 10px !important;
    i { display: none !important; }
  }
  
  h1.mea-subtitle {
    margin: 0 !important;
  }
  
  .priority-legend { 
    margin: 10px 0 20px 0 !important;
    
    .priority:first-child { margin-top: 0; }
    .priority:last-child { margin-bottom: 0; }
    .priority { 
      width: 100%; 
      text-align: center; 
      margin-left: 0 !important;
      margin-bottom: 5px;
    }
  }
  
  .row {}
  .row-categories{
    width: auto !important;
    text-align: center;

    .indicator-category {}
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FrontPage.vue